import { render, staticRenderFns } from "./TreeSimpleCard.vue?vue&type=template&id=b20f49fe&scoped=true&"
import script from "./TreeSimpleCard.vue?vue&type=script&lang=ts&"
export * from "./TreeSimpleCard.vue?vue&type=script&lang=ts&"
import style0 from "./TreeSimpleCard.vue?vue&type=style&index=0&id=b20f49fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f49fe",
  null
  
)

export default component.exports